import { hasAcceptedAnalyticsConsent } from './consent'
import { trackGa4Event } from './ga4'
import { trackYandexMetricaEvent } from './yandex-metrica'
import type { AnalyticsEventName, AnalyticsEventParams } from './events'

export const trackAnalyticsEvent = (
  eventName: AnalyticsEventName,
  params?: AnalyticsEventParams,
): void => {
  if (!hasAcceptedAnalyticsConsent()) {
    return
  }

  trackGa4Event(eventName, params)
  trackYandexMetricaEvent(eventName, params)
}
